<div class="footer">
    <small>
        Versão: <b>{{version}}</b>
    </small>
</div>